import { StepState } from 'src/app/core/enums/enums';
import { StepMiniState } from 'src/app/core/models/models';

export const splitStep: StepMiniState = {
  steps: [
    {
      title: 'involuntary-change.steps.split',
      state: StepState.Active
    },
    {
      title: 'involuntary-change.steps.aditionalInformation',
      state: StepState.Normal
    },
    {
      title: 'involuntary-change.steps.reviewItinerary',
      state: StepState.Normal
    },
    {
      title: 'Final',
      state: StepState.Normal
    }
  ],
  activeStep: 0
};

export const aditionalInformationStep: StepMiniState = {
  steps: [
    {
      title: 'involuntary-change.steps.split',
      state: StepState.Completed
    },
    {
      title: 'involuntary-change.steps.aditionalInformation',
      state: StepState.Active
    },
    {
      title: 'involuntary-change.steps.reviewItinerary',
      state: StepState.Normal
    },
    {
      title: 'Final',
      state: StepState.Normal
    }
  ],
  activeStep: 1
};

export const initialStepNextAditionalInformation: StepMiniState = {
  steps: [
    {
      title: 'involuntary-change.steps.split',
      state: StepState.Completed
    },
    {
      title: 'involuntary-change.steps.aditionalInformation',
      state: StepState.Completed
    },
    {
      title: 'involuntary-change.steps.reviewItinerary',
      state: StepState.Active
    },
    {
      title: 'Final',
      state: StepState.Normal
    }
  ],
  activeStep: 2
};

export const reRouteQuoteRequestFailStep: StepMiniState = {
  steps: [
    {
      title: 'involuntary-change.steps.split',
      state: StepState.Completed
    },
    {
      title: 'involuntary-change.steps.aditionalInformation',
      state: StepState.Completed
    },
    {
      title: 'involuntary-change.steps.reviewItinerary',
      state: StepState.Error
    },
    {
      title: 'Final',
      state: StepState.Muted
    }
  ],
  activeStep: 2
};

export const reRouteQuoteRequestSuccessStep: StepMiniState = {
  steps: [
    {
      title: 'involuntary-change.steps.split',
      state: StepState.Completed
    },
    {
      title: 'involuntary-change.steps.aditionalInformation',
      state: StepState.Completed
    },
    {
      title: 'involuntary-change.steps.reviewItinerary',
      state: StepState.Completed
    },
    {
      title: 'Final',
      state: StepState.Completed
    }
  ],
  activeStep: 3
};
